<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.mailFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.detailedBroadcastReport">{{ $t("message.detailedBroadcastReport") }}</a-checkbox>
                </div>
                <div class="feature-label">{{ $t("message.firstMailFreeCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.mailFreeCount" />
                </div>
                <div class="feature-label">{{ $t("message.maxMailLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.mailCount" />
                </div>
                <div class="feature-label">{{ $t("message.mailPerCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.mailPerCount" />
                </div>
                <div class="feature-label">{{ $t("message.mailPricePerCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.mailPerPrice" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            mailFreeCount: 0,
            mailCount: 0,
            mailPerCount: 0,
            mailPerPrice: 0,
            detailedBroadcastReport: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.MAIL);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.MAIL, ...this.featureForm };
                response[Features.MAIL.FREE_COUNT] = +v.mailFreeCount || 0;
                response[Features.MAIL.COUNT] = +v.mailCount || 0;
                response[Features.MAIL.PER_COUNT] = +v.mailPerCount || 0;
                response[Features.MAIL.PER_PRICE] = +v.mailPerPrice || 0;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.MAIL);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
